/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SingleTurnChatLanguageEnum } from './SingleTurnChatLanguageEnum';
import {
  SingleTurnChatLanguageEnumFromJSON,
  SingleTurnChatLanguageEnumFromJSONTyped,
  SingleTurnChatLanguageEnumToJSON,
} from './SingleTurnChatLanguageEnum';
import type { CredentialRead } from './CredentialRead';
import { CredentialReadFromJSON, CredentialReadFromJSONTyped, CredentialReadToJSON } from './CredentialRead';
import type { SingleTurnChatProtocolEnum } from './SingleTurnChatProtocolEnum';
import {
  SingleTurnChatProtocolEnumFromJSON,
  SingleTurnChatProtocolEnumFromJSONTyped,
  SingleTurnChatProtocolEnumToJSON,
} from './SingleTurnChatProtocolEnum';

/**
 *
 * @export
 * @interface SingleTurnChatInferencerSpitch
 */
export interface SingleTurnChatInferencerSpitch {
  /**
   *
   * @type {number}
   * @memberof SingleTurnChatInferencerSpitch
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof SingleTurnChatInferencerSpitch
   */
  name?: string | null;
  /**
   *
   * @type {SingleTurnChatProtocolEnum}
   * @memberof SingleTurnChatInferencerSpitch
   */
  protocol: SingleTurnChatProtocolEnum;
  /**
   *
   * @type {SingleTurnChatLanguageEnum}
   * @memberof SingleTurnChatInferencerSpitch
   */
  language: SingleTurnChatLanguageEnum;
  /**
   *
   * @type {CredentialRead}
   * @memberof SingleTurnChatInferencerSpitch
   */
  readonly credential: CredentialRead;
  /**
   *
   * @type {Date}
   * @memberof SingleTurnChatInferencerSpitch
   */
  timestamp?: Date;
  /**
   *
   * @type {string}
   * @memberof SingleTurnChatInferencerSpitch
   */
  spitchEndpoint: string;
  /**
   *
   * @type {string}
   * @memberof SingleTurnChatInferencerSpitch
   */
  spitchUserId: string;
  /**
   *
   * @type {string}
   * @memberof SingleTurnChatInferencerSpitch
   */
  spitchChannelId: string;
}

/**
 * Check if a given object implements the SingleTurnChatInferencerSpitch interface.
 */
export function instanceOfSingleTurnChatInferencerSpitch(value: object): value is SingleTurnChatInferencerSpitch {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('protocol' in value) || value['protocol'] === undefined) return false;
  if (!('language' in value) || value['language'] === undefined) return false;
  if (!('credential' in value) || value['credential'] === undefined) return false;
  if (!('spitchEndpoint' in value) || value['spitchEndpoint'] === undefined) return false;
  if (!('spitchUserId' in value) || value['spitchUserId'] === undefined) return false;
  if (!('spitchChannelId' in value) || value['spitchChannelId'] === undefined) return false;
  return true;
}

export function SingleTurnChatInferencerSpitchFromJSON(json: any): SingleTurnChatInferencerSpitch {
  return SingleTurnChatInferencerSpitchFromJSONTyped(json, false);
}

export function SingleTurnChatInferencerSpitchFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SingleTurnChatInferencerSpitch {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    name: json['name'] == null ? undefined : json['name'],
    protocol: SingleTurnChatProtocolEnumFromJSON(json['protocol']),
    language: SingleTurnChatLanguageEnumFromJSON(json['language']),
    credential: CredentialReadFromJSON(json['credential']),
    timestamp: json['timestamp'] == null ? undefined : new Date(json['timestamp']),
    spitchEndpoint: json['spitch_endpoint'],
    spitchUserId: json['spitch_user_id'],
    spitchChannelId: json['spitch_channel_id'],
  };
}

export function SingleTurnChatInferencerSpitchToJSON(
  value?: Omit<SingleTurnChatInferencerSpitch, 'id' | 'credential'> | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    name: value['name'],
    protocol: SingleTurnChatProtocolEnumToJSON(value['protocol']),
    language: SingleTurnChatLanguageEnumToJSON(value['language']),
    timestamp: value['timestamp'] == null ? undefined : value['timestamp'].toISOString(),
    spitch_endpoint: value['spitchEndpoint'],
    spitch_user_id: value['spitchUserId'],
    spitch_channel_id: value['spitchChannelId'],
  };
}
